export const feedbackSettingState = {
    isLoading: false,
    questionType: [],
    questionList:[],
    emojiImage:[],
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',
    statusCode:'',
    FeedbackTypesList:[]
}